
export class BaseProviderInstanceUser {
  providerId: string;
  providerInstanceId: string;
  providerInstanceResourceId: string;
}
